import { render, staticRenderFns } from "./ProjectsDetailHeader.vue?vue&type=template&id=7bfb62f2"
import script from "./ProjectsDetailHeader.vue?vue&type=script&lang=js"
export * from "./ProjectsDetailHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports